//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api";
import { server } from "@/services/constants";
import StockCard from "@/components/cards/StockCard";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "../computing/tolocalestringnumber";
import unity from "@/unity/unity";
const moment = require('moment');

export default {
  name: "New Activity",
  data() {
    return {
      dialogAdd: false,
      dialogSendMail: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      Emp_list: [],
      jobtitle_list: [],
      charge_list: [
        { value: "T/C", name: "Time Based" },
        { value: "N/C", name: "Non-Billable" },
        { value: "F/C", name: "Fixed Fee" },
        { value: "OFF", name: "Internal Office Work" },
      ],
      customer_list: [],
      menuDateCheckin: false,
      menuDateCheckout: false,
      dataItem: {
        userId: localStorage.getItem(server.USER_ID),
        customer_id: 0,
        jobtitle_id: 0,
        // checkin: "",
        // checkout: "",
        checkin: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        checkout: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        timecheckin: "",
        timecheckout: "",
        timecheckinadd: "",
        timecheckoutadd: "",
        hours: "",
        chargetype: "",
        prospect: "",
        detail: "",
        durationhour: 0,
        durationminute: 0,
      },
      statusActivity: "",
      showDuration: "",
      checklate: false,
      update_id: 0,
      itemduration: 0,
    };
  },
  components: {
    StockCard,
    SuccessDialog,
    SuccessDialogPush,
  },
  computed: {
    computedDateCheckInFormatted() {
      return unity.formatDate(this.dataItem.checkin);
    },
    minDateAllowed() {
      return moment().tz("Asia/Bangkok").subtract(5, 'days').format("YYYY-MM-DD");
    },
    computedDateCheckOutFormatted() {
      return unity.formatDate(this.dataItem.checkout);
    },
    isTodayCheckin() {
      const selected = new Date(this.dataItem.checkin);
      const today = new Date();
      return selected.toISOString().slice(0, 10) === today.toISOString().slice(0, 10);
    },
    isDisabledTimeField() {
      return this.isTodayCheckin && this.isPastCurrentTimeLimit();
    },
    isTodayCheckOut() {
      const selected = new Date(this.dataItem.checkout);
      const today = new Date();
      return selected.toISOString().slice(0, 10) === today.toISOString().slice(0, 10);
    },
    isDisabledTimeFieldCheckOut() {
      return this.isTodayCheckOut && this.isPastCurrentTimeLimitCheckOut();
    }
  },

  watch: {
    'dataItem.checkin'(newVal) {
      const today = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");

      if (newVal === today && this.dataItem.timecheckin) {
        const time = moment.tz(this.dataItem.timecheckin, "Asia/Bangkok");
        const now = moment.tz("Asia/Bangkok");

        if (time.isAfter(now)) {
          this.dataItem.timecheckin = null;
        }
      }
    },
    'dataItem.checkout'(newVal) {
      const today = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");

      if (newVal === today && this.dataItem.timecheckout) {
        const time = moment.tz(this.dataItem.timecheckout, "Asia/Bangkok");
        const now = moment.tz("Asia/Bangkok");

        if (time.isAfter(now)) {
          this.dataItem.timecheckout = null;
        }
      }
    }
  },

  async mounted() {
    await api.checkVersion();

    this.$forceUpdate();
    const userId = localStorage.getItem(server.USER_ID);
    if (userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
    this.loadEmp();
    this.loadCustomer();
    this.loadJobtitle();
    this.loadActivity();
    this.$hideLoader();
  },
  methods: {
    getMaxTime() {
      const selected = moment.tz(this.dataItem.checkin, "Asia/Bangkok").format("YYYY-MM-DD");
      const today = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");

      if (selected === today) {
        return moment.tz("Asia/Bangkok").format("HH:mm");
      }
      return null;
    },
    getMaxTimeCheckOut() {
      const selected = moment.tz(this.dataItem.checkout, "Asia/Bangkok").format("YYYY-MM-DD");
      const today = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");

      if (selected === today) {
        return moment.tz("Asia/Bangkok").format("HH:mm");
      }
      return null;
    },
    isPastCurrentTimeLimit() {
      // Optional: ใช้ได้ถ้าต้องการเงื่อนไขซับซ้อนกว่านี้
      return false;
    },
    isPastCurrentTimeLimitCheckOut() {
      // Optional: ใช้ได้ถ้าต้องการเงื่อนไขซับซ้อนกว่านี้
      return false;
    },
    async loadEmp() {
      const result = await api.getAccountslist_by_ComID(
        localStorage.getItem(server.COMPANYID)
      );

      this.Emp_list = result.data;
    },
    async loadCustomer() {
      const result = await api.getAllCustomerListactiveCompany(
        {
          params: {
            company_id: localStorage.getItem(server.COMPANYID),
          },
        }
      );
      this.customer_list = result.data;
    },
    async loadJobtitle() {
      const result = await api.getAllJobtitleByDepartment(
        {
          params: {
            company_id: localStorage.getItem(server.COMPANYID),
            department: localStorage.getItem(server.DEPARTMENT_ID),
          },
        }
      );

      this.jobtitle_list = result.data;
    },
    async loadActivity() {
      const resCheckInData = await api.getActivityByID(Number(this.$route.params.id))
      console.log(resCheckInData.data)
      this.dataItem.chargetype = resCheckInData.data[0].chargetype;
      this.dataItem.jobtitle_id = resCheckInData.data[0].jobtitleid;
      this.dataItem.customer_id = resCheckInData.data[0].customerid;
      this.dataItem.prospect = resCheckInData.data[0].prospect;
      this.dataItem.detail = resCheckInData.data[0].detail;

      this.dataItem.checkin = moment(resCheckInData.data[0].checkindate).format("YYYY-MM-DD");
      this.dataItem.checkout = this.dataItem.checkin;

      const baseDate = this.dataItem.checkin;
      this.dataItem.timecheckin = moment.tz(`${baseDate} ${resCheckInData.data[0].checkindate_time}`, 'YYYY-MM-DD HH:mm', 'Asia/Bangkok').format("YYYY-MM-DDTHH:mm:ss.SSSZ");
      this.dataItem.timecheckout = moment.tz(`${baseDate} ${resCheckInData.data[0].checkoutdate_time}`, 'YYYY-MM-DD HH:mm', 'Asia/Bangkok').format("YYYY-MM-DDTHH:mm:ss.SSSZ");

      await this.getWorkHourDuration()

    },
    async getWorkHourDuration() {
      if (
        this.dataItem.timecheckin !== "" &&
        this.dataItem.timecheckout !== ""
      ) {


        // ดึงเฉพาะเวลา (HH:mm) จาก string ISO
        const checkinTime = moment(this.dataItem.timecheckin).format("HH:mm");
        const checkoutTime = moment(this.dataItem.timecheckout).format("HH:mm");

        // สร้าง moment ใหม่โดยใช้วันที่เดียวกัน เช่น 2000-01-01 เพื่อไม่ให้วันมีผล
        const baseDate = "2000-01-01";
        const checkin = moment(`${baseDate} ${checkinTime}`, "YYYY-MM-DD HH:mm");
        const checkout = moment(`${baseDate} ${checkoutTime}`, "YYYY-MM-DD HH:mm");

        if (checkin.isSameOrAfter(checkout)) {
          this.dataItem.duration = 0;
          this.showDuration = "Start date/time must be before End date/time";
          return;
        }

        let totalMinutes = checkout.diff(checkin, "minutes");

        this.dataItem.duration = Number(totalMinutes)

        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        if (hours > 0) {
          if (minutes > 0) {
            this.showDuration = `${hours} Hours ${minutes} Minute`;
          } else {
            this.showDuration = `${hours} Hours`;
          }
        } else {
          this.showDuration = `${minutes} Minute`;
        }
      }
    },
    async save() {
      if (this.dataItem.userId == "" || this.dataItem.userId == null) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Employee ",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (
        this.dataItem.jobtitle_id == "" ||
        this.dataItem.jobtitle_id == null
      ) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Assignment ",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (this.dataItem.checkin == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Date",
          "text-h5 red--text text-center"
        );
        return;
      } else {
        this.dataItem.checkout = this.dataItem.checkin;
      }

      if (this.dataItem.timecheckin == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Start Time",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.dataItem.checkout == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด End Date",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.dataItem.timecheckout == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด End Time",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.dataItem.chargetype == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Charge-Type ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.dataItem.detail == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Details ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.dataItem.duration <= 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "Start date/time must be before End date/time",
          "text-h5 red--text text-center"
        );
        return;
      }





      var dataUpdate = {}
      dataUpdate.checkInDate = `${this.dataItem.checkin} ${moment(this.dataItem.timecheckin).format("HH:mm:ss")}`;
      dataUpdate.checkOutDate = `${this.dataItem.checkout} ${moment(this.dataItem.timecheckout).format("HH:mm:ss")}`;
      dataUpdate.duration = Number(this.dataItem.duration);
      dataUpdate.chargeType = this.dataItem.chargetype;
      dataUpdate.jobTitleId = this.dataItem.jobtitle_id;
      dataUpdate.customerId = this.dataItem.customer_id;
      dataUpdate.prospect = this.dataItem.prospect;
      dataUpdate.detail = this.dataItem.detail.replace(/'/g, "\\'");


      this.$showLoader();
      const res_updateAct = await api.updateActivityEdit(Number(this.$route.params.id), dataUpdate);
      this.$hideLoader()

      if (res_updateAct.status == 200 || res_updateAct.status == 201) {
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "Information Saved",
          "Information successfully saved",
          "text-h5 green--text text-center",
          "/my-activity"
        );
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "ไม่สามารถบันทึกได้",
          "text-h5 red--text text-center"
        );
        return;
      }
    },

    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
  async beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
  async created() { },
};
